// Imports
var ___CSS_LOADER_API_IMPORT___ = require("./node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".box_outline{border:2px solid #ddd}.box_outline_dark{border:1px solid #00499b}h1,h2,h3,h4,h5,h6{font-family:Cinzel,serif!important;font-weight:400!important;margin-bottom:0!important}h1,h2,h3,h4,h5,h6,p{margin-top:0!important}p{font-family:Mulish,sans-serif!important;font-size:18px!important;margin-bottom:2em!important}.blue_icon,.blue_icon svg{color:#01499b}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
